export default __webpack_public_path__ + "static/blog-1-04ea5c48f8d0d8f1f2776e334b0f57b9.jpg";